import {
  Avatar,
  Box,
  Button,
  Flex,
  HStack,
  Image,
  Text,
  VStack,
} from '@chakra-ui/react'
import {CommonColors} from '@utils/CommonStyles'
import LocationIcon from '@assets/svgs/lern-part-three/location.svg'
import StarIcon from '@assets/svgs/lern-part-three/star.svg'
import FlagIcon from '@assets/svgs/lern-part-three/flag.svg'
import {ReactComponent as EyeIcon} from '@assets/svgs/eye.svg'
import AvatarDefault from '@assets/images/avatar-msg-part-two.png'
import {useState} from 'react'
const OutlineMsg = ({msg}: {msg: any}) => {
  const [isShow, setIsShow] = useState(false)

  return (
    <HStack align="start" spacing={4}>
      <Avatar
        src={AvatarDefault}
        size="sm"
        borderRadius={'50%'}
        border={'2px solid #E4E7EC'}
      />
      <VStack
        maxWidth={'80%'}
        align="start"
        spacing={4}
        bg={'white'}
        p={'16px'}
        borderRadius={'12px'}>
        <Text color={CommonColors.primary} fontSize={'16px'} fontWeight={'500'}>
          {msg?.title}
        </Text>
        <Flex flexDirection={'column'} gap={'8px'}>
          <Flex className={'outline-item'} gap={'16px'}>
            <Flex
              flexDirection={'column'}
              minH={'100px'}
              alignItems={'center'}
              gap={'8px'}>
              <Image
                src={LocationIcon}
                alt="flag"
                width={'48px'}
                height={'48px'}
              />
              <Box flex={1} w={'2px'} bg={'#E4E7EC'} />
            </Flex>
            <Flex flexDirection={'column'}>
              <Text fontSize={'16px'} fontWeight={'600'}>
                {msg?.data?.open?.header}
              </Text>
              {isShow && (
                <Text fontSize={'16px'} color={'#344054'}>
                  {msg?.data?.open?.content}
                </Text>
              )}
            </Flex>
          </Flex>
          {msg?.data?.main_ideas?.map((item: any, index: number) => (
            <Flex key={index} className={'outline-item'} gap={'16px'}>
              <Flex
                flexDirection={'column'}
                minH={'100px'}
                alignItems={'center'}
                gap={'8px'}>
                <Image
                  src={StarIcon}
                  alt="flag"
                  width={'48px'}
                  height={'48px'}
                />
                <Box flex={1} w={'2px'} bg={'#E4E7EC'} />
              </Flex>
              <Flex flexDirection={'column'}>
                <Text fontSize={'16px'} fontWeight={'600'}>
                  {item?.header}
                </Text>
                {isShow && (
                  <Text fontSize={'16px'} color={'#344054'}>
                    {item?.content}
                  </Text>
                )}
              </Flex>
            </Flex>
          ))}
          <Flex className={'outline-item'} gap={'16px'}>
            <Flex
              flexDirection={'column'}
              minH={'100px'}
              alignItems={'center'}
              gap={'8px'}>
              <Image src={FlagIcon} alt="flag" width={'48px'} height={'48px'} />
            </Flex>
            <Flex flexDirection={'column'}>
              <Text fontSize={'16px'} fontWeight={'600'}>
                {msg?.data?.close?.header}
              </Text>
              {isShow && (
                <Text fontSize={'16px'} color={'#344054'}>
                  {msg?.data?.close?.content}
                </Text>
              )}
            </Flex>
          </Flex>
        </Flex>
        {!isShow && (
          <Flex justifyContent={'center'} mx="auto">
            <Button
              rightIcon={<EyeIcon />}
              variant={'outline'}
              borderColor={'#D0D5DD'}
              color={'#344054'}
              sx={{
                path: {
                  stroke: '#344054',
                },
              }}
              onClick={() => {
                setIsShow(true)
              }}>
              Xem gợi ý cơ
            </Button>
          </Flex>
        )}
      </VStack>
    </HStack>
  )
}

export default OutlineMsg
